// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.unsavedChangesHandler.UnsavedChangesActionResponse
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class UnsavedChangesActionResponse {
  static createUnsavedChangesActionResponse(actionComplete, unsavedChangesFound) {
    const retVal = new UnsavedChangesActionResponse();
    retVal.initUnsavedChangesActionResponse(actionComplete, unsavedChangesFound);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createUnsavedChangesActionResponse factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadu.UnsavedChangesActionResponse";
  }
  initFromJson(json, deserializeContext) {
    this.initUnsavedChangesActionResponse(json.actionComplete, json.unsavedChangesFound);
  }
  initUnsavedChangesActionResponse(actionComplete, unsavedChangesFound) {
    this._actionComplete = actionComplete;
    this._unsavedChangesFound = unsavedChangesFound;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["actionComplete"] = this._actionComplete;
    retVal["unsavedChangesFound"] = this._unsavedChangesFound;
    return retVal;
  }
  get actionComplete() {
    return this._actionComplete;
  }
  set actionComplete(value) {
    this._actionComplete = value;
  }
  get unsavedChangesFound() {
    return this._unsavedChangesFound;
  }
  set unsavedChangesFound(value) {
    this._unsavedChangesFound = value;
  }
}
//# sourceMappingURL=UnsavedChangesActionResponse.js.map
